<template>
    <div>
        <div class="title-container">
            <div class="title-wrapper">
                <img src="@/assets/img/title1.png" alt="" class="title-img">
                <div class="title-label">今日直播</div>
            </div>
        </div>
        <div class="live-today-container">
            <div class="live-today-order-wrapper">
                <div class="live-today-order-title">
                    企业所得税申报表变动要点解析与税务角度
                    重大风险控制(北京)
                </div>
                <div class="live-today-order-date">
                    <span>03月28日 19:00-20:30</span>
                    <span class="live-today-order-num">90人已预约</span>
                </div>
                <div class="live-today-order-btn">立即预约</div>
                <div class="live-today-order-teacher-wrapper">
                    <img src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png" alt="" class="order-teacher-img">
                    <span class="live-today-order-teacher">主讲：李老师</span>
                </div>
            </div>
            <div class="live-today-list-wrapper">
                <div class="list-wrapper">
                    <div v-for="(item,index) in listData" :key="'list-'+index" class="list-item" :style="index%2==0?'background:rgb(248,248,248);':''">
                        <div class="list-index-wrapper">
                            <div class="list-dat"></div>
                            <div v-if="index!=listData.length-1" class="list-line"></div>
                        </div>
                        <div class="list-content">
                            <div class="list-date">{{item.date}}</div>
                            <div class="list-content-label">{{item.title}}</div>
                        </div>
                        <div class="list-brief">
                            <div>主讲：{{item.name}}</div>
                            <div class="list-role-btn">会员</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="title-container">
            <div class="title-wrapper">
                <img src="@/assets/img/title2.png" alt="" class="title-img">
                <div class="title-label">全部直播</div>
            </div>
            <div class="table-tab-wrapper">
                <div :class="activeNav=='course-list'?'table-tab-item-active':'table-tab-item'" 
                @click="handleNav('course-list')">
                    课程列表
                    <div v-if="activeNav=='course-list'" class="table-tab-line-wrapper">
                        <div class="table-tab-line"></div>
                    </div>
                </div>
                <div :class="activeNav=='formative-test'?'table-tab-item-active':'table-tab-item'" 
                @click="handleNav('formative-test')">
                    阶段测试
                    <div v-if="activeNav=='formative-test'" class="table-tab-line-wrapper">
                        <div class="table-tab-line"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="table-wrapper">
            <div v-for="(item,index) in tableData" :key="'table-'+index" class="table-item"
            :style="index%4==3?'':'margin-right:20px;'">
                <div>
                    <img src="@/assets/img/1.png" alt="" class="table-img">
                </div>
                <div class="table-content-wrapper">
                    <div class="table-content">
                        <div class="table-name">
                            {{item.title}}
                        </div>
                        <div class="table-date">时间：{{item.date}}</div>
                        <div class="table-date">讲师：{{item.name}}</div>
                        <div class="table-price-wrapper">
                            <div class="table-price">￥ {{item.price}}</div>
                            <div class="table-view-btn">立即观看</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: '',
    components:{
      
    },
    data() {
        return {
            listData:[
                {
                    title:'企业纳税精细化管理(高级)',
                    date:'19:00',
                    name:'李老师',
                    role:1
                },
                {
                    title:'企业纳税精细化管理(高级)',
                    date:'19:00',
                    name:'李老师',
                    role:1
                },
                {
                    title:'企业纳税精细化管理(高级)',
                    date:'19:00',
                    name:'李老师',
                    role:1
                },
                {
                    title:'企业纳税精细化管理(高级)',
                    date:'19:00',
                    name:'李老师',
                    role:1
                },
                {
                    title:'企业纳税精细化管理(高级)',
                    date:'19:00',
                    name:'李老师',
                    role:1
                }
            ],
            tableData:[
                {
                    title:'管理会计高级战略成本管理与成本管理管理会计战略成本',
                    date:'11-26 16:00-20:00',
                    name:'李老师',
                    price:3280
                },
                {
                    title:'管理会计高级战略成本管理与成本管理管理会计战略成本',
                    date:'11-26 16:00-20:00',
                    name:'李老师',
                    price:3280
                },
                {
                    title:'管理会计高级战略成本管理与成本管理管理会计战略成本',
                    date:'11-26 16:00-20:00',
                    name:'李老师',
                    price:3280
                },
                {
                    title:'管理会计高级战略成本管理与成本管理管理会计战略成本',
                    date:'11-26 16:00-20:00',
                    name:'李老师',
                    price:3280
                },
                {
                    title:'管理会计高级战略成本管理与成本管理管理会计战略成本',
                    date:'11-26 16:00-20:00',
                    name:'李老师',
                    price:3280
                },
                {
                    title:'管理会计高级战略成本管理与成本管理管理会计战略成本',
                    date:'11-26 16:00-20:00',
                    name:'李老师',
                    price:3280
                },
                {
                    title:'管理会计高级战略成本管理与成本管理管理会计战略成本',
                    date:'11-26 16:00-20:00',
                    name:'李老师',
                    price:3280
                },
                {
                    title:'管理会计高级战略成本管理与成本管理管理会计战略成本',
                    date:'11-26 16:00-20:00',
                    name:'李老师',
                    price:3280
                },
                {
                    title:'管理会计高级战略成本管理与成本管理管理会计战略成本',
                    date:'11-26 16:00-20:00',
                    name:'李老师',
                    price:3280
                },
                {
                    title:'管理会计高级战略成本管理与成本管理管理会计战略成本',
                    date:'11-26 16:00-20:00',
                    name:'李老师',
                    price:3280
                },
                {
                    title:'管理会计高级战略成本管理与成本管理管理会计战略成本',
                    date:'11-26 16:00-20:00',
                    name:'李老师',
                    price:3280
                },
                {
                    title:'管理会计高级战略成本管理与成本管理管理会计战略成本',
                    date:'11-26 16:00-20:00',
                    name:'李老师',
                    price:3280
                }
            ],
            activeNav:'course-list',
        }
    },
    mounted(){
        scrollTo(0,0);
    },
    methods: {
        handleNav(target){
            this.activeNav=target;
        }
    }
}
</script>

<style scoped>
.title-container{
    display:flex;
    justify-content: space-between;
    align-items: center;
    padding-top:43px;
}
.title-wrapper{
    display: flex;
    align-items: center;
}
.title-label{
    font-size: 20px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
    margin-left:10px;
}
.title-img{
    width:29px;
    height:23px;
}
.live-today-container{
    height:360px;
    margin-top:20px;
    display:flex;
}
.live-today-order-wrapper{
    flex:1;
    height: 100%;
    background: rgb(222,234,255);
    display:flex;
    flex-direction: column;
    position:relative;
}
.live-today-list-wrapper{
    flex:1;
    height:100%;
    background: #fff;
    display:flex;
}
.live-today-order-title{
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #292C2E;
    margin:65px 67px 20px 67px;
}
.live-today-order-date{
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    margin:0px 67px 47px 67px;
}
.live-today-order-num{
    margin-left:20px;
}
.live-today-order-btn{
    width: 144px;
    height: 40px;
    background: #FFFFFF;
    border-radius: 6px;
    border: 1px solid #4F79ED;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #4F79ED;
    margin:0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}
.live-today-order-btn:hover{
    cursor: pointer;
    background: #4F79ED;
    color:#fff;
}
.live-today-order-teacher-wrapper{
    display: flex;
    align-items: center;
    position:absolute;
    bottom:28px;
    left:28px;
}
.order-teacher-img{
    width:46px;
    height:46px;
    border-radius:50%;
}
.live-today-order-teacher{
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #292C2E;
    margin-left:12px;
}
.list-wrapper{
    flex:1;
}
.list-item{
    display:flex;
    justify-content: space-between;
    align-items: center;
    padding:10px 0px 10px 0px;
    position:relative;
    padding-left:10px;
    padding-right:10px;
}
.list-content{
    flex:1;
    display: flex;
    align-items: center;
}
.list-brief{
    width:200px;
    display:flex;
    align-items: center;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
}
.list-role-btn{
    width:80px;
    height:36px;
    background:rgb(230,242,255);
    text-align: center;
    line-height:36px;
    margin-left:20px;
    color:#4F79ED;
    border-radius:5px;
}
.list-content-label{
    width:300px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 600;
    color: #666666;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
}
.list-date{
    font-size: 13px;
    color:#666;
    margin-left:20px;
    margin-right:10px;
}
.list-index-wrapper{
    position:absolute;
    left:10px;
    top:24px;
    z-index:30;
}
.list-dat{
    width:10px;
    height:10px;
    border-radius:50%;
    background:#4F79ED;
}
.list-line{
    width:1px;
    height:25px;
    background:#4F79ED;
    position:relative;
    left:4px;
    top:9px;
    opacity:0.7;
}
.table-wrapper{
    display:flex;
    flex-wrap: wrap;
    margin-top:30px;
    margin-bottom:60px;
}
.table-item{
    width:285px;
    background: #FFFFFF;
    border-radius:5px;
    margin-bottom:20px;
}
.table-img{
    width:100%;
    height:176px;
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
}
.table-content-wrapper{
    display: flex;
    flex-direction: column;
}
.table-content{
    flex:1;
    margin:11px 13px 18px 13px;
}
.table-name{
    width:100%;
    height:42px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
}
.table-date{
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #848F9A;
    margin-top:8px;
}
.table-price-wrapper{
    margin-top:11px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.table-price{
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FF9645;
}
.table-view-btn{
    width: 88px;
    height: 36px;
    border-radius: 6px;
    border: 1px solid #4F79ED;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #4F79ED;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}
.table-view-btn:hover{
    cursor: pointer;
    background: #4F79ED;
    color:#fff;
}
.table-tab-wrapper{
    display:flex;
}
.table-tab-item{
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    position: relative;
    margin-left:30px;
    height:28px;
    line-height: 28px;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
    cursor: pointer;
}
.table-tab-item-active{
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 600;
    color: #666666;
    position: relative;
    margin-left:30px;
    height:28px;
    line-height: 28px;
    cursor: pointer;
}
.table-tab-line-wrapper{
    width:100%;
    position: absolute;
    bottom:-8px;
    left:0px;
    display: flex;
    justify-content: center;
}
.table-tab-line{
    width: 22px;
    height: 4px;
    background: #3E63EE;
    border-radius: 3px;
}
</style>


